export default __webpack_public_path__ + "static/media/martin_nair.44d6624e.png";